
/*
* VueAwesomeSwiper ssr.js
* Author: surmon@foxmail.com
* Github: https://github.com/surmon-china/vue-awesome-swiper
*/

// Require sources
import _Swiper from 'swiper/dist/js/swiper.js'
import objectAssign from 'object-assign'

import { debounce } from 'lodash'

const Swiper = window.Swiper || _Swiper

// as of swiper 4.0.7
// http://idangero.us/swiper/api/#events
const DEFAULT_EVENTS = [
  'beforeDestroy',
  'slideChange',
  'slideChangeTransitionStart',
  'slideChangeTransitionEnd',
  'slideNextTransitionStart',
  'slideNextTransitionEnd',
  'slidePrevTransitionStart',
  'slidePrevTransitionEnd',
  'transitionStart',
  'transitionEnd',
  'touchStart',
  'touchMove',
  'touchMoveOpposite',
  'sliderMove',
  'touchEnd',
  'click',
  'tap',
  'doubleTap',
  'imagesReady',
  'progress',
  'reachBeginning',
  'reachEnd',
  'fromEdge',
  'setTranslate',
  'setTransition',
  'resize'
]

var globalEventHandler = {}
// swiperDirective
const swiperDirective = globalOptions => {
  // Get swiper instace name in directive
  const getInstanceName = (el, binding, vnode) => {
    let instanceName = null
    if (binding.arg) {
      instanceName = binding.arg
    } else if (vnode.data.attrs && (vnode.data.attrs.instanceName || vnode.data.attrs['instance-name'])) {
      instanceName = (vnode.data.attrs.instanceName || vnode.data.attrs['instance-name'])
    } else if (el.id) {
      instanceName = el.id
    }
    return instanceName || 'swiper'
  }

  // const matchMedia = () => {
  //   const checkMedia = window.matchMedia('(max-width: 1099px)')
  //   return !!checkMedia.matches
  // }
  const mq = window.matchMedia('(max-width: 1099px)')

  const createSwiper = (el, binding, vnode) => {
    const self = vnode.context
    const options = binding.value
    const instanceName = getInstanceName(el, binding, vnode)

    const swiperObj = vnode.context[instanceName]

    if (swiperObj) {
      return
    }

    if (globalEventHandler[instanceName + '_' + vnode.context._uid]) {
      let swiper = self[instanceName]

      // Emit event in Vue directive
      const eventEmit = (vnode, name, data) => {
        const handlers = (vnode.data && vnode.data.on) ||
                          (vnode.componentOptions && vnode.componentOptions.listeners)
        if (handlers && handlers[name]) handlers[name].fns(data)
      }

      if (!swiper) {
        const swiperOptions = objectAssign({}, globalOptions, options)
        swiper = self[instanceName] = new Swiper(el, swiperOptions)
        setTimeout(function () {
          swiper.reInit && swiper.reInit()
        })
        DEFAULT_EVENTS.forEach(eventName => {
          swiper.on(eventName, function () {
            eventEmit(vnode, eventName, ...arguments)
            eventEmit(vnode, eventName.replace(/([A-Z])/g, '-$1'), ...arguments)
          })
        })
      }

      eventEmit(vnode, 'ready', swiper)
    }
  }

  const updateSwiper = (el, binding, vnode) => {
    const instanceName = getInstanceName(el, binding, vnode)
    const swiper = vnode.context[instanceName]

    if (swiper) {
      swiper.reInit && swiper.reInit()
      swiper.update && swiper.update()
      swiper.navigation && swiper.navigation.update()
      swiper.pagination && swiper.pagination.render()
      swiper.pagination && swiper.pagination.update()
      swiper.updateContainerSize && swiper.updateContainerSize()
    }
  }

  const destroySwiper = (el, binding, vnode) => {
    const instanceName = getInstanceName(el, binding, vnode)
    const swiper = vnode.context[instanceName]
    if (swiper) {
      swiper.destroy && swiper.destroy()
      delete vnode.context[instanceName]
    }
  }

  return {
    handlerId: '',

    // Init
    bind (el, binding, vnode) {
      const instanceName = getInstanceName(el, binding, vnode)

      if (el.className.indexOf('swiper-container') === -1) {
        el.className += ((el.className ? ' ' : '') + 'swiper-container')
      }

      globalEventHandler[instanceName + '_' + vnode.context._uid] = () => {
        if (mq.matches) {
          debounce(function () {
            destroySwiper(el, binding, vnode)
            createSwiper(el, binding, vnode)
            // updateSwiper(el, binding, vnode)
          }, 200).call()
        } else {
          debounce(function () {
            destroySwiper(el, binding, vnode)
            // updateSwiper(el, binding, vnode)
          }, 200).call()
        }
      }

      if (window.addEventListener ) {
        window.addEventListener('resize', globalEventHandler[instanceName + '_' + vnode.context._uid])
      } else {
        window.attachEvent('onresize', globalEventHandler[instanceName + '_' + vnode.context._uid])
      }
    },

    // DOM inserted
    inserted (el, binding, vnode) {
      if (mq.matches) {
        createSwiper(el, binding, vnode)
      }
    },
    // Parse options change
    componentUpdated (el, binding, vnode) {
      updateSwiper(el, binding, vnode)
    },

    // Destroy this directive
    unbind (el, binding, vnode) {
      const instanceName = getInstanceName(el, binding, vnode)

      destroySwiper(el, binding, vnode)

      if (window.addEventListener ) {
        window.removeEventListener('resize', globalEventHandler[instanceName + '_' + vnode.context._uid])
      } else {
        window.detachEvent('onresize', globalEventHandler[instanceName + '_' + vnode.context._uid])
      }

      delete globalEventHandler[instanceName + '_' + vnode.context._uid]
    }
  }
}

// swiperDirective
const swiper = swiperDirective({})

// Global swiper default options
const install = function (Vue, globalOptions = {}) {
  // Mount swiper directive for Vue global
  var promoDetailSwiperOptions =
  {
    slidesPerView: 'auto',
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination'
    },
    observer: true,
    observeParents: true
  }
  Vue.directive('swiper', swiperDirective(promoDetailSwiperOptions))
}

const VueAwesomeSwiper = { Swiper, swiper, install }

export { Swiper, swiper, install }
export default VueAwesomeSwiper



// WEBPACK FOOTER //
// ./src/plugins/_common/VueSwiper.js